export { CardShoppingItemEntityMobile } from './card-shopping-item';
